import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Container,
  Paper,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const HelpCenter = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language?.startsWith('ar');

  const faqItems = [
    { q: t('help_q1_question'), a: t('help_q1_answer') },
    { q: t('help_q2_question'), a: t('help_q2_answer') },
    { q: t('help_q3_question'), a: t('help_q3_answer') },
    { q: t('help_q4_question'), a: t('help_q4_answer') },
    { q: t('help_q5_question'), a: t('help_q5_answer') },
    { q: t('help_q6_question'), a: t('help_q6_answer') },
  ];

  return (
    <Container maxWidth="md" sx={{ py: { xs: 2, md: 4 } }} dir={isRTL ? 'rtl' : 'ltr'}>
      <Paper
        elevation={2}
        sx={{
          p: { xs: 2, md: 3 },
          borderRadius: 2,
          mb: 2,
          background: 'linear-gradient(135deg, rgba(188,31,65,0.08) 0%, rgba(188,31,65,0.02) 100%)',
          border: '1px solid rgba(188,31,65,0.16)',
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1.25}>
          <HelpOutlineIcon color="primary" />
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700 }} color="primary.main">
              {t('help_title')}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {t('help_subtitle')}
            </Typography>
          </Box>
        </Stack>
      </Paper>

      <Paper elevation={2} sx={{ p: { xs: 1, md: 2 }, borderRadius: 2 }}>
        {faqItems.map((item, index) => (
          <Accordion
            key={index}
            disableGutters
            sx={{
              '&:before': { display: 'none' },
              borderBottom: index < faqItems.length - 1 ? '1px solid #eceff3' : 'none',
              boxShadow: 'none',
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography sx={{ fontWeight: 600 }}>{item.q}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography color="text.secondary" sx={{ whiteSpace: 'pre-line' }}>
                {item.a}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Paper>
    </Container>
  );
};

export default HelpCenter;
